import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import TuneIcon from '@material-ui/icons/Tune';
import IconButton from '@material-ui/core/IconButton';

class RestrictionButton extends React.Component {

    render() {

        return (
            <Tooltip title={this.props.title}>
                <span>
                    <IconButton
                        disabled={this.props.disabled} data-test={this.props.dataTest} size="small" onClick={this.props.onClick}>
                        {this.props.icon}
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
}

RestrictionButton.defaultProps = {
    icon: <TuneIcon fontSize="small" />,
    disabled: false,
};

RestrictionButton.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default RestrictionButton;